import { Link } from "react-router-dom";
import { GlassCard } from "../components/GlassCard.js";
import { Icon } from "../components/Icon.js";

export function NotFoundPage() {
  return (
    <GlassCard className="col-span-12 p-xl flex flex-col items-center text-center gap-md min-h-[320px] justify-center">
      <Icon name="error_outline" className="text-error" style={{ fontSize: "48px" }} />
      <h1 className="text-headline-md text-on-background">Route not found</h1>
      <p className="text-body-sm text-on-surface-variant">
        The page you tried to open doesn't exist in the admin shell.
      </p>
      <Link
        to="/"
        className="px-4 py-2 bg-primary-container text-on-primary-container rounded-lg text-label-xs uppercase tracking-widest font-mono"
      >
        Back to dashboard
      </Link>
    </GlassCard>
  );
}
